// extracted by mini-css-extract-plugin
module.exports = {"container":"get-in-touch_container__6rWxn","title":"get-in-touch_title__nFP6R","subtitle":"get-in-touch_subtitle__VYzGo"};